import React from 'react';
import "./StoryReel.css";
import Story from './Story.js';

function StoryReel() {
    return (
        <div className="story__first">
        <div className="storyReel">
            <Story 
                image="https://images.idgesg.net/images/article/2019/06/dark_web_dark_net_warning_sign_alert_caution_danger_by_thomas-bethge_gettyimages-1151411167_black_and_yellow_warning_stripes_background_by_croc80_gettyimages-483040586_2400x1600-100800632-large.jpg"
                profileSrc="https://specials-images.forbesimg.com/imageserve/5da5c84c6763cb000608c51e/960x0.jpg"
                title="Dark Web"
            />
            <Story 
                image="https://campuslifesecurity.com/-/media/SEC/CSLS/Images/2019/12/CyberHackLaptop.jpg"
                profileSrc="https://www.securitysales.com/wp-content/uploads/2019/09/AdobeStock_182344447.jpeg"
                title="Hacker"
            />
            <Story 
                image="https://i.insider.com/5e94b6f492e8ba7ff267c6d6?width=1100&format=jpeg&auto=webp"
                profileSrc="https://img.srgcdn.com/e//N0lqaEg1UXJUMFhweUE4U3pLSmQucG5n.jpg"
                title="Selena"
            />
            <Story 
                image="https://i.pinimg.com/originals/69/4f/3c/694f3c3865ca3d3df986073966bc3d76.jpg"
                profileSrc="https://i.pinimg.com/originals/d5/8f/06/d58f06808cd59c79912b5d22f082e12b.jpg"
                title="Hooney"
            />
            <Story 
                image="https://i.pinimg.com/originals/c5/f1/0a/c5f10addc1a7aa5b2fb562626d3509f3.jpg"
                profileSrc="https://i.pinimg.com/originals/71/bb/1f/71bb1f71e3eaddc338a6012a6a04e775.jpg"
                title="Elezander"
                className="reduce__story"
            />
        </div>
        </div>
    )
}

export default StoryReel
